import { routes } from "src/shared/routes";
import { FAQS, TERMS_AND_CONDITION, AnalyticsHeader } from "./helper";

import type { TTeamConfig } from "src/shared/types/teamConfig.types";

export const orlandomagic_pass: TTeamConfig = {
  TEAM_SCHEMA: "orlandomagic_pass",
  TEAM_FULL_NAME: "Orlando Magic",
  BROWSER_TITLE: "Slam Dunk Pass",
  CLIENT_ID: "2af95a60a522.seasonshare.magic-magic.us",

  IMAGES: {
    LOGO_URL:
      "https://ss-leagues.s3.amazonaws.com/NBA/Orlando%20Magic%20Marketing%20Assets/global-logo.png",
    ORDER_SUMMERY_BACKGROUND_URL:
      "https://ss-leagues.s3.amazonaws.com/NBA/Orlando%20Magic%20Marketing%20Assets/102225_MIA_ORL_GB23502.jpg",
    LANDING_PAGE_STATIC_BANNER_URL:
      "https://ss-leagues.s3.amazonaws.com/NBA 2024-25/magic-v3/FBFP-LandingPage-Desktop.jpg",
    MOBILE_LANDING_PAGE_STATIC_BANNER_URL:
      "https://ss-leagues.s3.amazonaws.com/NBA 2024-25/magic-v3/FBFP-LandingPage-Mobile.jpg",
    GROUP_INVITE_PAGE_STATIC_BANNER_URL:
      "https://ss-leagues.s3.amazonaws.com/NBA 2024-25/magic-v3/FBFP-LoggedIn-Desktop.jpg",
  },
  LANGUAGES: {
    FAQS,
    TERMS_AND_CONDITION,
    PRE_PURCHASE_FAQS: FAQS,
  },

  TEAM_GLOBAL_SETTINGS: {
    COLORS_PRIMARY: "#0050b5",
    COLORS_SECONDARY: "#C4ced4",
    DEFAULT_APP_ROUTE: routes.landing,
    LOGOUT_ON_INVALID_SESSION: true,
    IS_INTERCOM_ENABLED: true,

    NAV_MENU: {
      HIDE_MANAGE_SUBSCRIPTION: true,
      HIDE_EARN_REWARDS: true,
    },
    FOOTER: {
      BACKGROUND_COLOR: "#000000",
    },
    ANALYTICS_HEADER: AnalyticsHeader,
  },

  LANDING_PAGE_SETTINGS: {
    PASS_BANNER: {
      IS_FLUID_BACKGROUND_IMAGE_SIZE: true,
      DISABLE_BACKGROUND_IMAGE_FILTER: true,
      PASS_DISPLAY_MODE: "separate",
    },
    PASS: {
      HIDE_DECIMAL_POINTS_AFTER_PRICE: true,
      SUBSCRIBE_BUTTON_TEXT: "Buy Now",
      SHOW_FAQ_BUTTON: true,
    },
  },
  HOME_PAGE_SETTINGS: {
    EVENT_CARD: {
      ADD_ON_DISPLAY_MODE: "list",
      SHOW_SINGLE_GAMES_IN_COLLAPSE: true,
    },
    ADD_ON: {
      ADD_SERVICE_FEE_TO_PRICE: true,
    },
  },
  GROUP_INVITE_PAGE_SETTINGS: {
    PASS_BANNER: {
      DISABLE_BACKGROUND_IMAGE_FILTER: true,
      PASS_DISPLAY_MODE: "separate",
    },
  },
  CHECKOUT_PAGE_SETTINGS: {
    CHECKOUT_FORM: {
      SAVE_CARD_SWITCH_ENABLED: false,
    },
  },
  MANAGE_SUBSCRIPTION_PAGE_SETTINGS: {
    SUBSCRIPTION_DETAILS: {
      HIDE_RESUME_SUBSCRIPTION_BUTTON: true,
    },
    ZERO_STATE: {
      OPT_OUT_EARLIEST_DATE: new Date("10/01/2024"),
    },
  },
};
